/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// Email domains that we are not going to validate.

// This is maintained at
// https://github.com/mailcheck/mailcheck/wiki/List-of-Popular-Domains (aside
// from the MOZ section)
// Mailcheck.defaultDomains is much shorter than this list.

const TopEmailDomains = new Set([
  '126.com',
  '163.com',
  '21cn.com',
  'abv.bg',
  'alice.it',
  'aliyun.com',
  'aol.com',
  'aol.it',
  'arcor.de',
  'arnet.com.ar',
  'att.net',
  'bell.net',
  'bellsouth.net',
  'bigpond.com',
  'bk.ru',
  'bluewin.ch',
  'blueyonder.co.uk',
  'bol.com.br',
  'bt.com',
  'btinternet.com',
  'charter.net',
  'comcast.net',
  'cox.net',
  'daum.net',
  'earthlink.net',
  'email.com',
  'email.it',
  'facebook.com',
  'fastmail.fm',
  'fibertel.com.ar',
  'foxmail.com',
  'free.fr',
  'freemail.hu',
  'freenet.de',
  'freeserve.co.uk',
  'games.com',
  'globo.com',
  'globomail.com',
  'gmai.com',
  'gmail.com',
  'gmil.com',
  'gmx.at',
  'gmx.com',
  'gmx.de',
  'gmx.fr',
  'gmx.net',
  'google.com',
  'googlemail.com',
  'hanmail.net',
  'hotmail.be',
  'hotmail.ca',
  'hotmail.co.uk',
  'hotmail.com.ar',
  'hotmail.com.br',
  'hotmail.com.mx',
  'hotmail.com',
  'hotmail.de',
  'hotmail.es',
  'hotmail.fr',
  'hotmail.it',
  'hush.com',
  'hushmail.com',
  'icloud.com',
  'ig.com.br',
  'iname.com',
  'inbox.com',
  'inbox.ru',
  'interia.pl',
  'itelefonica.com.br',
  'juno.com',
  'keemail.me',
  'laposte.net',
  'lavabit.com',
  'libero.it',
  'list.ru',
  'live.be',
  'live.co.uk',
  'live.com.ar',
  'live.com.mx',
  'live.com',
  'live.de',
  'live.fr',
  'live.it',
  'live.nl',
  'love.com',
  'mac.com',
  'mail.com',
  'mail.ru',
  'me.com',
  'mozilla.com',
  'msn.com',
  'nate.com',
  'naver.com',
  'neuf.fr',
  'ntlworld.com',
  'o2.co.uk',
  'o2.pl',
  'oi.com.br',
  'online.de',
  'op.pl',
  'orange.fr',
  'orange.net',
  'outlook.com.br',
  'outlook.com',
  'outlook.de',
  'outlook.es',
  'outlook.fr',
  'pobox.com',
  'poste.it',
  'prodigy.net.mx',
  'protonmail.ch',
  'protonmail.com',
  'qq.com',
  'r7.com',
  'rambler.ru',
  'rediffmail.com',
  'restmail.net',
  'rocketmail.com',
  'rogers.com',
  'safe-mail.net',
  'sbcglobal.net',
  'seznam.cz',
  'sfr.fr',
  'shaw.ca',
  'sina.cn',
  'sina.com',
  'sky.com',
  'skynet.be',
  'speedy.com.ar',
  'sympatico.ca',
  't-online.de',
  'talktalk.co.uk',
  'telenet.be',
  'teletu.it',
  'terra.com.br',
  'tin.it',
  'tiscali.co.uk',
  'tiscali.it',
  'tuta.io',
  'tutamail.com',
  'tutanota.com',
  'tutanota.de',
  'tvcablenet.be',
  'ukr.net',
  'uol.com.br',
  'verizon.net',
  'virgilio.it',
  'virgin.net',
  'virginmedia.com',
  'voo.be',
  'wanadoo.co.uk',
  'wanadoo.fr',
  'web.de',
  'wow.com',
  'wp.pl',
  'ya.ru',
  'yahoo.ca',
  'yahoo.co.id',
  'yahoo.co.in',
  'yahoo.co.jp',
  'yahoo.co.kr',
  'yahoo.co.uk',
  'yahoo.com.ar',
  'yahoo.com.au',
  'yahoo.com.br',
  'yahoo.com.mx',
  'yahoo.com.ph',
  'yahoo.com.sg',
  'yahoo.com.tw',
  'yahoo.com',
  'yahoo.de',
  'yahoo.es',
  'yahoo.fr',
  'yahoo.gr',
  'yahoo.it',
  'yandex.com',
  'yandex.ru',
  'yeah.net',
  'ygm.com',
  'ymail.com',
  'zipmail.com.br',
  'zoho.com',
]);

export default TopEmailDomains;
